import moment from "moment";
import { FC } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { FaCalendarAlt } from "react-icons/fa";
import classes from "./style.module.scss";
import {
  getDateModeFormat,
  getNextDate,
  isDayBefore,
  isDayEnabled,
} from "../../../helpers/datetime";
import { TCalendarType } from "./calendar_types";
import date from "../../../assets/images/date_icon.svg";
const DateDisplayArrow: FC<{
  fromDate: string;
  toDate: string;
  mode: TCalendarType;
  onForward: () => void;
  onBack: () => void;
  onClick: () => void;
}> = ({ fromDate, toDate, mode, onForward, onBack, onClick }) => {
  return (
    <div className="flex inline-flex items-center">
      {mode != "CUSTOM" && mode != "ALL" && (
        <BsChevronLeft
          className={`br-50 ${isDayBefore('2022-01-01', fromDate) ? "cursor-pointer" : ""
            } bg-white ${classes.icon}`}
          onClick={() => {
            if (isDayBefore('2022-01-01', fromDate)) {
              onBack();
            }
          }}
        />
      )}
      <span
        className="flex items-center grow text-center mx-4 color-blue cursor-pointer"
        onClick={onClick}
      >
        <img src={date} />
        <span className="ml-1" style={{ overflow: "hidden" }}>
          <span>{getDateModeFormat(mode, fromDate, toDate)}</span>
        </span>
      </span>
      {mode != "CUSTOM" && mode != "ALL" && (
        <BsChevronRight
          className={`br-50 ${isDayEnabled(getNextDate(toDate)) ? "cursor-pointer" : ""
            } bg-white ${classes.icon}`}
          onClick={() => {
            if (isDayEnabled(getNextDate(toDate))) {
              onForward();
            }
          }}
        />
      )}
    </div>
  );
};

export default DateDisplayArrow;
